import { FINISHED_SETTLEMENTS_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IApiResponse } from "../../models";

interface CashoutProps {
  contractId?: string;
  referenceTransactionId?: string;
  page: number;
  size: number;
  organizationCode?: string;
}

const defaultProvide = async () => await getToken();

export const getPendingCashouts = ({
  contractId = "",
  referenceTransactionId = "",
  page = 0,
  size = 10,
  organizationCode,
}: CashoutProps): Promise<IApiResponse> => {
  let searchKeyWord = "";
  if (contractId) searchKeyWord = contractId?.replace("+", "%2B");
  const url = `${FINISHED_SETTLEMENTS_URL}?status=CASH_OUT_APPROVED,PARTIALLY_RELEASED&type=QUICK_TRANSACTION,MILESTONE_CONTRACT,BROKERAGE_CONTRACT&page=${page}&size=${size}${
    contractId ? `&searchKeyWord=${searchKeyWord}` : ""
  }${
    referenceTransactionId
      ? `&referenceTransactionId=${referenceTransactionId}`
      : ""
  }${organizationCode ? `&organizationCode=${organizationCode}` : ""}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const getFinishedCashouts = ({
  contractId = "",
  referenceTransactionId = "",
  page = 0,
  size = 10,
  organizationCode,
}: CashoutProps): Promise<IApiResponse> => {
  let searchKeyWord = "";
  if (contractId) searchKeyWord = contractId?.replace("+", "%2B");
  const url = `${FINISHED_SETTLEMENTS_URL}?status=COMPLETED,EXCEPTIONAL_COMPLETED&type=QUICK_TRANSACTION&page=${page}&size=${size}${
    contractId ? `&searchKeyWord=${searchKeyWord}` : ""
  }${
    referenceTransactionId
      ? `&referenceTransactionId=${referenceTransactionId}`
      : ""
  }${organizationCode ? `&organizationCode=${organizationCode}` : ""}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};
